import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";

// css
import styles from "../../layout/Auth/Auth.module.scss";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { OTP_VERIFY, RESET_PASSWORD } from "../../services/ApiCalls";
import { toast } from "react-toastify";

const schema = z
  .object({
    otp: z
      .string()
      .min(4, { message: "otp is required" })
      .refine((data) => !isNaN(data), {
        message: "Otp only contain a Numeric value",
      }),
    password: z.string().min(1, { message: "Password is required" }),
    confirmPassword: z
      .string()
      .min(1, { message: "confirm Password is required" }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords does not match",
  });

const ResetPassword = ({ email }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    reValidateMode: "onChange",
    mode: "onChange",
  });

  const navigate = useNavigate();
  const submitHandler = async (data) => {
    const otpVerifyRes = await OTP_VERIFY({
      email,
      OTP: data.otp,
    });

    if (otpVerifyRes?.data?.status === "success") {
      const resetRes = await RESET_PASSWORD({
        email,
        password: data.password,
        confirmPassword: data.confirmPassword,
      });
      if (resetRes?.data?.status === "success") {
        toast.success(resetRes?.data?.message);
        navigate("/login");
      } else {
        toast.error(resetRes?.data?.message);
      }
    } else {
      toast.error(otpVerifyRes?.data?.message);
    }
  };

  return (
    <div className="w-100 inner">
      <div className="top py-2 top-head-reset">
        <h4 className="m-0 fw-sbold">Reset Password</h4>
      </div>
      <Form className={`${styles.form}`} onSubmit={handleSubmit(submitHandler)}>
        <Row>
          <Col lg="12" className="my-2">
            <input
              type="text"
              className={`${styles.formControl} form-control bg-white`}
              placeholder="OTP"
              {...register("otp")}
            />
            {<p className="errorColor">{errors?.otp && errors.otp.message}</p>}
          </Col>
          <Col lg="12" className="my-2">
            <input
              type="password"
              className={`${styles.formControl} form-control bg-white`}
              placeholder="New Password"
              {...register("password")}
            />
            {
              <p className="errorColor">
                {errors?.password && errors.password.message}
              </p>
            }
          </Col>
          <Col lg="12" className="my-2">
            <input
              type="password"
              className={`${styles.formControl} form-control bg-white`}
              placeholder="Confirm Password"
              {...register("confirmPassword")}
            />
            {
              <p className="errorColor">
                {errors?.confirmPassword && errors.confirmPassword.message}
              </p>
            }
          </Col>
          <Col lg="8" className="my-2">
            <div className={`${styles.btnWrpper} btnWrpper`}>
              <Button
                className="d-flex align-items-center justify-content-center w-100 commonBtn"
                type="submit"
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ResetPassword;
